import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useMe } from './useAuth.js';

const UNREAD_KEY = ['transactions', 'unread-count'] as const;

/**
 * Polls every 30s while the tab is in focus. Returns 0 when signed out so
 * callers can render unconditionally without flicker.
 */
export function useUnreadCount() {
  const me = useMe();
  return useQuery({
    queryKey: UNREAD_KEY,
    queryFn: () => api.transactions.unreadCount(),
    enabled: Boolean(me.data?.user),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    staleTime: 15_000,
  });
}

/** Marks every other-party message in this booking read; refreshes the badge. */
export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.transactions.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: UNREAD_KEY });
    },
  });
}
